// extracted by mini-css-extract-plugin
module.exports = {"hero":"PartnershipsHero_hero__g5-3V","applybutton":"PartnershipsHero_applybutton__1BbGL","map":"PartnershipsHero_map__20h1K"};